import { firestore } from "./FirebaseService";
import { doc, onSnapshot } from "firebase/firestore";
import { onMounted, onUnmounted, ref as vueRef } from 'vue'
import { getUid } from "./AuthService";
import { sendMessage } from "./MessagesService";
import { useMessagesStore } from "@/stores/useMessagesStore";

const VENDOR_ID = process.env.VUE_APP_VENDOR_ID;

const contact = vueRef({})

//Save contact information and send system message indicating contact captured
export function saveContactInfo(contactData) {
  const uid = getUid();
  if (!uid) return;
  const chatId = useMessagesStore().ensureChatId();

  const updateData = {};

  // Only add truthy parameters to the update
  if (contactData.name && contactData.name != '') updateData.name = contactData.name;
  if (contactData.email && contactData.email != '') updateData.email = contactData.email;
  if (contactData.phone && contactData.phone != '') updateData.phone = contactData.phone;

  sendMessage(uid, chatId,
    'You submitted the following contact information: ',
    'submit_contact_info',
    {contactInfo: contactData}
  );
}

//update contact information and send system message indicating contact captured
export function updateContactInfo(contactData) {
  const uid = getUid();
  if (!uid) return;
  const chatId = useMessagesStore().ensureChatId();

  const updateData = {};

  // Only add truthy parameters to the update
  if (contactData.name && contactData.name != '') updateData.name = contactData.name;
  if (contactData.email && contactData.email != '') updateData.email = contactData.email;
  if (contactData.phone && contactData.phone != '') updateData.phone = contactData.phone;

  sendMessage(uid, chatId,
    'You updated your contact information: ',
    'update_contact_info',
    {contactInfo: contactData}
  );
}

/**
 * Sets up listener for contact info
 * @param {string} uid 
 * @param {Function} onContactInfoChanged - Callback when contact info changes
 * @returns {Function} Cleanup function to stop listening
 */
export function subscribeToContactInfo(uid, onContactInfoChanged) {
  const leadDoc = doc(firestore, `vendors/${VENDOR_ID}/leads/${uid}`);
  return onSnapshot(leadDoc, (snap) => {
    if (!onContactInfoChanged) return;
    if (!snap.exists()) {
      onContactInfoChanged({ status: null });
      return;
    }
    const data = snap.data();
    // Expose phone alias so existing consumers keep working.
    onContactInfoChanged({ ...data, phone: data.phone_number ?? null });
  });
}

//Observe Contact information in database
export function observeContactInfo() {
  const uid = getUid();
  if (!uid) return;

  let stopListening = null

  onMounted(() => {
    stopListening = subscribeToContactInfo(uid, (value) => {
      contact.value = value
    })
  })

  onUnmounted(() => {
    if (stopListening)
      stopListening()
  })

  return contact
}